/* src/app/forms/simple-datagrid/grid-color-configuration/grid-color-configuration.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
.edit-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
mat-form-field {
  width: 100%;
}
.span1 {
  margin-left: 10px;
}
.mat-expansion-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
}
textarea {
  height: 100%;
  resize: none;
}
mat-toolbar-row {
  display: flex;
  flex-direction: row;
}
.textarea {
  height: 100%;
}
.full {
  height: 100%;
}
.customtextarea {
  position: absolute;
}
:host ::ng-deep .customtextarea {
}
:host ::ng-deep .customtextarea .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea .mat-form-field-infix {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-flex {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-wrapper {
  height: 100% !important;
}
:host ::ng-deep .customtextarea.mat-form-field-appearance-outline > .mat-form-field-infix {
  height: 100% !important;
}
.fields {
  width: 100%;
  display: flex;
  flex-direction: row;
  font-size: 10px;
  padding-left: 10px;
  height: 100%;
  justify-content: space-between;
  align-items: center;
}
.form-formula {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  min-height: 150px;
}
.container-data {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.button-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-end;
  padding-top: 4px;
}
/*# sourceMappingURL=grid-color-configuration.component.css.map */
